import { Component, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { CommentHistoryModalComponent } from '../comment-history-modal/comment-history-modal.component';
import { NotificationComponent } from 'src/app/shared/layouts/notification/notification.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';

@Component({
  selector: 'app-resubmit-clarify',
  templateUrl: './resubmit-clarify.component.html',
  styleUrls: ['./resubmit-clarify.component.css']
})
export class ResubmitClarifyComponent implements OnInit {
  isArabic: any;
  userDetails: any;
  rejectedQuestions: any;
  assessmentDetails: any;
  userData: any;
  isMakerCheckerEnabled: any;
  modalRef!: BsModalRef;
  modalRefDeactivate!: BsModalRef;
  isDeactivated = false;

  questionnaireList: any;
  assessmentForm!: FormGroup;
  assessment!: any;
  questionnaireEvent = new EventEmitter();


  constructor(private storageService: StorageService, private assessmentService: AssessmentService,
    private commonService: CommonService, private route: Router, private modalService: BsModalService,
    public formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.assessmentForm = this.formBuilder.group({
      questionnaire: ['', [Validators.required]]
    });
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.userDetails = this.storageService.getSessionStorageData('userDetails');
    this.isMakerCheckerEnabled = this.storageService.getSessionStorageData('isMakerCheckerEnabled');
    //console.log(this.userDetails);
    const rqstBodydata = { contactId: this.userDetails?.contactId };
    this.assessmentService.getUserData(rqstBodydata).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      //console.log('get user data in user profile: ', decryptedData);
      this.userData = JSON.parse(JSON.stringify(decryptedData));
      //console.log('user details in request user access: ', this.userData);
      if (!this.userData?.isActivate) {
        this.isDeactivated = true;
      }
    });

    const rqstBody = { assessmentUnit: this.userDetails?.assessmentUnitValue, contactguid: this.userDetails?.contactguid };
    this.assessmentService.fetchSubmittedQuestionnaires(rqstBody).subscribe((res) => {

      // const REJECTED_STATUS = this.isMakerCheckerEnabled ?
      //   GlobalConstants.STATUSES.CHECKER_REJECTED.name :
      //   GlobalConstants.STATUSES.REJECTED.name;

        const REJECTED_STATUS = this.isMakerCheckerEnabled ?
        GlobalConstants.STATUSES.CHECKER_REJECTED.value :
        GlobalConstants.STATUSES.INSPECTOR_REJECTED.value;

      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      //console.log('get submitted questionnaire list in assessment: ', decryptedData);
      let resp = JSON.parse(JSON.stringify(decryptedData));
      this.questionnaireList = resp?.questionnaires?.filter((ques: any) => ques.status
        == REJECTED_STATUS && ques.questionnaireMdeValue != null);
      //console.log('list of submitted questionnaires: ', this.questionnaireList);

      //let selectedQuestionnaire;
      if (this.questionnaireList.length > 0) {
        //selectedQuestionnaire = this.questionnaireList[0];
        this.assessmentForm.controls['questionnaire'].setValue(this.questionnaireList[0].questionnaireId);
        this.assessment = JSON.stringify(this.questionnaireList[0]);
                  // console.log("fetchSubmittedQuestionnaires setting questionaireevent assessment")

        this.questionnaireEvent.emit(this.assessment);
      }
    }, (error: any) => {
      //console.log('server error check: ', error);
      if (error?.body?.error == 'The Assossicated Assessment Entity has deactivated') {
        this.showDeactivationPopup();
      }
    });


  }

  selectQuestionnaire(evt: any) {
    let selectedAssessmentId = evt.target?.value;
    if (selectedAssessmentId !== '') {
      let selectedAssessment = this.questionnaireList.filter((ele: any) => ele?.questionnaireId == selectedAssessmentId);
      if (selectedAssessment.length > 0) {
        this.assessment = JSON.stringify(selectedAssessment[0]);
        this.questionnaireEvent.emit(this.assessment);
      }
    } else {
      this.questionnaireEvent.emit(null);
    }
    //console.log('in asessment: ', this.assessment);

  }



  showDeactivationPopup() {
    let pathUrl = 'login';
    let message = '';
    if (this.isArabic) {
      message = '.تم إلغاء تنشيط كيان الاتصال / التقييم';
    } else {
      message = 'Contact/Assessment Entity has been deactivated.';
    }
    const initialState = {
      message: message,
      redirectTo: pathUrl,
      cancelButton: false
    };
    this.modalRefDeactivate = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }


}
